import { Magazine } from './types';

type Props = {
  magazines: Magazine[];
};

/**
 * The wall of covers.
 *
 * The cards are not links, as they were not at the source: these are Zinio's titles, and
 * a good part of the catalogue is not on our site at all — a link that sometimes goes
 * nowhere is worse than a card that never pretends to.
 *
 * No price under the cover, unlike Magzter Gold's grid. Zinio quotes no standalone figure
 * for a title anywhere in its catalogue response, so there is nothing to strike through;
 * headless_jshop rendered these cards without one for the same reason.
 */
export default function MagazineGrid({ magazines }: Props) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6">
      {magazines.map((magazine, index) => (
        // Zinio's own id, falling back to the position for a title that arrives without
        // one — headless keyed every card on the index, so this is no worse anywhere and
        // is stable where an id exists.
        <div key={magazine.id || `position-${index}`}>
          <div className="border-2 border-slate-100 rounded-lg h-52 sm:h-60 md:h-64 lg:h-72 w-full overflow-hidden mb-2">
            <img src={magazine.image} alt={magazine.name} loading="lazy" className="w-full h-full" />
          </div>
          <div className="font-semibold">{magazine.name}</div>
        </div>
      ))}
    </div>
  );
}
